// 法律
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/法律.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 法律服务咨询
        </p>
      </div>

      <h1 class="title">法律服务咨询</h1>
      <p
        class="jianjie"
      >根据建筑行业发展动态，针对工程招投标、合同谈判与签订，项目实施过程中诸如工期、质量、造价、担保、保险、损害赔偿、工伤、劳务纠纷等方面的问题，为客户提供专业化法律咨询服务。同时，也可为客户提供企业并购、对外投资合作、公司治理等方面的服务咨询。</p>
    </div>
    <div class="img"></div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/法律.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    // padding: 0px 360px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
    }
    .title {
      opacity: 1;
      font-size: 35px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
    }
    .jianjie {
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 30px;
      text-align: left;
      color: #231815;
      text-indent: 2em;
    }
  }
}
.img {
  width: 1200px;
  height: 600px;
  background: url("../assets/img/法律/一 拷贝 2@3x.png") center no-repeat;
  background-size: 100%;
  margin: 0px auto;
}
</style>
